var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[
    'tag',
    { tooltip: _vm.tooltipTitle && _vm.type === 'outgoing' },
    { downloaded: _vm.receiver.filesSent && _vm.type === 'outgoing' },
    { error: _vm.receiver.failed }
  ],attrs:{"tooltip-title":_vm.tooltipText}},[_c('span',{staticClass:"status-icon"}),_c('human-icon',{attrs:{"width":"11px","height":"12px","cssClass":"person"}}),_c('span',[_vm._v(_vm._s(_vm._f("emailName")(_vm.receiver.email)))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }